/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { RevokeInvitationMutationResponse, RevokeInvitationPathParams, RevokeInvitation400, RevokeInvitation401, RevokeInvitation403, RevokeInvitation404, RevokeInvitation409, RevokeInvitation500 } from "../../types/staffController/RevokeInvitation.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { revokeInvitation } from "../../client/staffController/revokeInvitation.ts";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const revokeInvitationMutationKey = () => [{ url: '/api/organizations/:organizationId/invitations/:invitationId' }] as const

export type RevokeInvitationMutationKey = ReturnType<typeof revokeInvitationMutationKey>

export function revokeInvitationMutationOptions<TContext = unknown>(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const mutationKey = revokeInvitationMutationKey()
        return mutationOptions<RevokeInvitationMutationResponse, ResponseErrorConfig<RevokeInvitation400 | RevokeInvitation401 | RevokeInvitation403 | RevokeInvitation404 | RevokeInvitation409 | RevokeInvitation500>, {organizationId: RevokeInvitationPathParams["organizationId"], invitationId: RevokeInvitationPathParams["invitationId"]}, TContext>({
          mutationKey,
          mutationFn: async({ organizationId, invitationId }) => {
            return revokeInvitation(organizationId, invitationId, config)
          },
        })

}

/**
 * @summary Revoke invitation
 * {@link /api/organizations/:organizationId/invitations/:invitationId}
 */
export function useRevokeInvitation<TContext>(options: 
{
  mutation?: UseMutationOptions<RevokeInvitationMutationResponse, ResponseErrorConfig<RevokeInvitation400 | RevokeInvitation401 | RevokeInvitation403 | RevokeInvitation404 | RevokeInvitation409 | RevokeInvitation500>, {organizationId: RevokeInvitationPathParams["organizationId"], invitationId: RevokeInvitationPathParams["invitationId"]}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? revokeInvitationMutationKey()

          const baseOptions = revokeInvitationMutationOptions(config) as UseMutationOptions<RevokeInvitationMutationResponse, ResponseErrorConfig<RevokeInvitation400 | RevokeInvitation401 | RevokeInvitation403 | RevokeInvitation404 | RevokeInvitation409 | RevokeInvitation500>, {organizationId: RevokeInvitationPathParams["organizationId"], invitationId: RevokeInvitationPathParams["invitationId"]}, TContext>
          

          return useMutation<RevokeInvitationMutationResponse, ResponseErrorConfig<RevokeInvitation400 | RevokeInvitation401 | RevokeInvitation403 | RevokeInvitation404 | RevokeInvitation409 | RevokeInvitation500>, {organizationId: RevokeInvitationPathParams["organizationId"], invitationId: RevokeInvitationPathParams["invitationId"]}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<RevokeInvitationMutationResponse, ResponseErrorConfig<RevokeInvitation400 | RevokeInvitation401 | RevokeInvitation403 | RevokeInvitation404 | RevokeInvitation409 | RevokeInvitation500>, {organizationId: RevokeInvitationPathParams["organizationId"], invitationId: RevokeInvitationPathParams["invitationId"]}, TContext>
      
}